import React from 'react';
import styled, { css } from 'styled-components';

import Icon from '@/assets/svg/exclamation_point-2.svg';
import { media } from '@/utils/mixin';

export default function DetailedCarInfoMessage({ text }: { text: string }) {
  return (
    <Component>
      <Icon />
      <Text>{text}</Text>
    </Component>
  );
}

const Component = styled.div`
  margin-top: 35px;
  display: flex;
  align-items: center;

  svg {
    flex: 0 0 18px;
    width: 18px;

    path {
      fill: ${(props) => props.theme.black100_alpha50};
    }
  }

  ${media.mobile(css`
    margin-top: 0;

    svg {
      flex: 0 0 12px;
      width: 12px;
    }
  `)}
`;

const Text = styled.span`
  margin-left: 8px;
  font-size: 14px;
  line-height: 14px;
  color: ${(props) => props.theme.black100_alpha50};

  ${media.mobile(css`
    font-size: 9px;
    line-height: 14px;
  `)}
`;
